import Model from "./base/model";
import Client from "../http/client";

class exportReport extends Model {
  resourceName() {
    return "export_report";
  }

  fields() {
    return {
      created_at: "",
      invoice: "",
      delivery_city: "",
      checked_rows: "",
      freight: "",
      nf_service: "",
      order_status: "",
      address_alias_delivery: "",
      cost_center: "",
      period: "",
      order_number: "",
      is_traceable: "",
      vehicle_plate: "",
      shipper: "",
      transporter: "",
      export_order_type: "",
      modal: "",
      shipment_number: "",
      non_conformity: "",
      project_name: "",
      follow: "",
      followed_by_user: "",
    };
  }

  async exportOrders(params, payload) {
    return this.request(
       this.resourceName() + '/orders',
      'POST',
      params,
      payload,
    );
  }

  async exportPurchaseOrders(filters) {
    return this.request(
       this.resourceName() +"/purchase_orders",
      "POST",
      {},
      filters,
    );
  }

  async exportOrdersDocumentsRelation(filters) {
    return this.request(
      this.resourceName() +"/documents_relation",
      "POST",
      {},
      filters,
    );
  }

  async exportTransporters(filters) {
    return this.request(
      this.resourceName() +"/transporters",
      "POST",
      {},
      filters,
    );
  }

  async exportFobOrders(params, payload) {
    return this.request(
       this.resourceName() + '/fob_orders',
      'POST',
      params,
      payload,
    );
  }

  async exportRequests(params, payload) {
    return this.request(
       this.resourceName() + '/requests',
      'POST',
      params,
      payload,
    );
  }

  async exportOccurrences(params, payload) {
    return this.request(
       this.resourceName() + '/occurrences',
      'POST',
      params,
      payload,
    );
  }
}


export default new exportReport();
